import { INLAND_FREIGHT_SERVICES } from '@pelicargo/utils';
import { FreightService } from '@prisma/client';
import { createContext, ReactNode } from 'react';

import { TrpcOutputs } from '../config/trpc';
import { useCargos } from '../hooks/cargo/useCargos';
import { useQuotes } from '../hooks/quote/useQuotes';
import { GetRequestOutput, useRequest } from '../hooks/request/useRequest';
import { useParams } from '../hooks/useParams';
import { Quote } from '../utils/types';

type CargoOutput = TrpcOutputs['createCargo'];

type Context = {
  request?: GetRequestOutput;
  refetchRequest: () => Promise<unknown>;
  quotes?: Quote[];
  afrQuotes?: Quote[];
  inlandQuotes?: Quote[];
  isLoadingQuotes: boolean;
  isLoadingAfrQuotes: boolean;
  isLoadingInlandQuotes: boolean;
  isLoadingRequest: boolean;
  cargoList: CargoOutput[];
};

export const CurrentRequestContext = createContext({} as Context);

type Props = {
  children: ReactNode;
};

export const CurrentRequestProvider = ({ children }: Props) => {
  const { requestId: id } = useParams<{ requestId: number }>();
  const { data: request, isLoading: isLoadingRequest, refetch: refetchRequest } = useRequest(id, {});
  const [quotes, isLoadingQuotes] = useQuotes(id);
  const [afrQuotes, isLoadingAfrQuotes] = useQuotes(id, [FreightService.AFR]);
  const [inlandQuotes, isLoadingInlandQuotes] = useQuotes(id, INLAND_FREIGHT_SERVICES);
  const [cargoList] = useCargos(id);

  return (
    <CurrentRequestContext.Provider
      value={{
        // TODO: this is technically a partial...
        request,
        refetchRequest,
        quotes,
        afrQuotes,
        inlandQuotes,
        isLoadingQuotes,
        isLoadingAfrQuotes,
        isLoadingInlandQuotes,
        isLoadingRequest,
        cargoList,
      }}
    >
      {children}
    </CurrentRequestContext.Provider>
  );
};
